import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import App from "../../../../templates/src/App/App";

gsap.registerPlugin(ScrollTrigger);

const StockLocatorDetail = {
    scrollBind: false,

    init() {
        this.el = $('[template="stock_locator"][page="detail"]');
        if (!this.el.length) return;

        this.top = this.el.find('[template="car"] [container="top"]');
        this.info = this.top.find('[block="info"]');
        this.basics = this.el.find('[template="car"] [container="basics"]');
        this.contact = this.el.find('[template="Contact"]');

        if (!App.isDesktop) return;
        this.bindPin();
        this.bindAnimation();
    },

    bindPin() {
        this.scrollBind = true;

        ScrollTrigger.create({
            id: 'topPin',
            trigger: this.top,
            pin: true,
            start: "top 118px",
            endTrigger: this.contact,
            end: "top 440px",
            invalidateOnRefresh: true,
            // markers: true
        });

        ScrollTrigger.create({
            id: 'basicsPin',
            trigger: this.basics,
            pin: true,
            start: "top 280px",
            endTrigger: this.contact,
            end: "top 440px",
            invalidateOnRefresh: true,
            // markers: true
        });
    },

    bindAnimation() {

        const tl = gsap.timeline({
            scrollTrigger: {
                id: 'topAnim',
                trigger: this.el.find('.holder'),
                scrub: true,
                start: "top=+118px 118px",
                endTrigger: this.el,
                end: "top -530px",
                invalidateOnRefresh: true,
                // markers: true
            }
        });

        tl.to(this.top.find('.holder'), {height: 220}, 0)
        tl.to(this.info, {width: '77%', paddingBottom: 0}, 0)
        tl.to(this.top.find('[block="slider"]'), {height: 220 - 64}, 0)
        tl.to(this.top.find('[block="slider"] .slider'), {scale: 0.32}, 0)
        tl.to(this.info, {className: 'scrolled'}, 0.3)
    },

    resize() {
        if (!this.el.length) return;
        if (!App.isDesktop) {
            ScrollTrigger.getById('topPin') && ScrollTrigger.getById('topPin').kill(true);
            ScrollTrigger.getById('basicsPin') && ScrollTrigger.getById('basicsPin').kill(true);
            ScrollTrigger.getById('topAnim') && ScrollTrigger.getById('topAnim').kill(true);
            this.scrollBind = false;
        } else {
            if (!this.scrollBind) {
                this.bindPin();
                this.bindAnimation();
            }
        }
    },

}

export default StockLocatorDetail;